// extracted by mini-css-extract-plugin
export default {"badgeContainer":"Badge_badgeContainer__eyYgo"};